import React from 'react';
import { message, Space, Table, Modal } from 'antd';
import { FormOutlined, AppstoreAddOutlined, TransactionOutlined } from '@ant-design/icons';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';
import dayjs from  'dayjs';

export const columns = [
    {
        title: '订单号',
        dataIndex: 'payNo',
        render: (text, record) => {
            text = text.split('-')[0];
            return <><a href={`/order/detail?shopId=${record.shopId}&orderId=${record.orderId}`}>{text}</a></>
        }
    },
    {
        title: '支付号',
        dataIndex: 'payNo',
    },
    {
        title: '支付时间',
        dataIndex: 'payTime',
        render: (text) => <>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</>
    },
    {
        title: '支付方式',
        dataIndex: 'payMethod',
        render: (text) => <>微信</>
    },
    {
        title: '支付渠道号',
        dataIndex: 'channelTrxNo',
    },
    {
        title: '支付金额(元)',
        dataIndex: 'amount',
        fixed: 'right',
        render: (text) => <>{text/100}</>
    },
    {
        title: '已退款',
        dataIndex: 'refund',
        render: (text) => <>{text === 1 ? '是' : '否'}</>
    },
    {
        title: '状态',
        dataIndex: 'status',
        fixed: 'right',
        render: (text) => {
            const statusMap = {
                0: '待结算',
                1: '结算中',
                2: '已结算',
            }
            return <>{statusMap[text] || '未知'}</>
        }
    },
    {
        title: '操作',
        // dataIndex: 'action',
        fixed: 'right',
        render: (text, record) => {
            return <Space> 
                {(record.status === 1 && record.accId === window.__baseInfo.accId) && <a onClick={() => profitSharing(record.payId)}>分账</a>}
                {/* <a onClick={() => profitSharing(record.payId)}>分账</a> */}
                <a href={`/pay/detail?payId=${record.payId}`}>详情</a>
            </Space>
        }
    }
];

const profitSharing = (payId) => {
    Modal.confirm({
        title: '分账',
        content: '确定分账吗？',
        onOk: async () => {
            const response = await fetch(`/api/pay/wx-profit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    payId,
                })
            });
            const result = await response.json();

            if(result?.success) {
                message.success('分账成功');
            } else {
                message.error('分账失败', result.data);
            }
        },
    });
}

export default () => {
    const [shopId, setShopId] = React.useState(null);
    const [payList, setPayList] = React.useState([]);
    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 10,
        total: 0,
        simple: true,
        showSizeChanger: false,
    });
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            reloadData();
        }
    }, [shopId]);
    
    // 获取订单列表
    const getOrderList = async (params = {}) => {
        const ps = new URLSearchParams();
        ps.append('shopId', shopId);
        Object.keys(params).forEach(key => {
            ps.append(key, params[key]);
        });

        const response = await fetch(`/api/pay/list?${ps.toString()}`);
        return await response.json();
    }

    const reloadData = async (params) => { 
        getOrderList(params).then(res => {
            setPayList(res?.data?.rows || []);
            setPagination({...pagination, current: params?.page || 1, total: res?.data?.count || 0});
        });
    }


    const onTableChange = (pagination) => {
        console.log('pagination', pagination);
        const {current, pageSize} = pagination;
        reloadData({page: current, pageSize});
        // setPagination(pagination);
    };

    return (
        <div>
            <SwitchShop />
            <h2 className="admin-page-title">支付流水</h2>
            <Table size='small' 
                pagination={pagination} 
                rowKey={'payId'} 
                columns={columns} 
                dataSource={payList} 
                scroll={{ x: 'max-content' }} 
                onChange={onTableChange}
            />
        </div>
    );
};